import { Component } from '@angular/core';
import { BaseDocumentListComponent } from '@dato-pages/base/base-document-list/base-document-list.component';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';

@Component({
    providers: ServiceBagServices,
    selector: 'app-ledger-list',
    templateUrl: './ledger-list.component.html',
    styleUrls: ['./ledger-list.component.scss', '../../../base/base-document-list/base-document-list.component.scss']
})
export class LedgerListComponent extends BaseDocumentListComponent {

    KeyExpr = ["EntryID", "LineID"];

    constructor(A: ServiceBagService) {
        super(A);
    }
}
